<template>
  <div class="min-h-screen">
    <div class="relative">
      <div class="ssc-wrapper">
        <div class="banner">
          <div class="ssc-square mb w-full h-full"></div>
        </div>
        <div class="absolute w-full text-gray-300" style="top: 300px">
          <div
            class="flex flex-col items-center justify-center text-center mb-8 -mt-8"
          >
            <div class="w-64 mb-2">
              <div class="ssc-head-line"></div>
            </div>
            <div class="w-28">
              <div class="ssc-line"></div>
            </div>
          </div>
          <div class="relative w-11/12 mx-auto bg-gray-900 p-3 py-6 z-2 mb-16">
            <keep-alive>
              <component :is="component" />
            </keep-alive>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, markRaw, onMounted, watch } from "vue";
import { useRoute } from "vue-router";
import SkeletonMovie from "./SkeletonMovie";
import SkeletonCasts from "./SkeletonCasts";
export default {
  name: "skeleton-movie-details",
  setup() {
    const route = useRoute();
    let component = ref();

    const DynamicComponent = () => {
      route.matched.map(match => {
        if (match.path === "/movies/:id/casts") {
          component.value = markRaw(SkeletonCasts);
        }
        if (match.path === "/movies/:id") {
          component.value = markRaw(SkeletonMovie);
        }
      });
    };

    onMounted(() => {
      DynamicComponent();
    });

    watch(
      () => route.path,
      () => {
        DynamicComponent();
      }
    );

    return { component };
  }
};
</script>

<style lang="scss" scoped>
.banner {
  position: relative;
  width: 100%;
  background-position: center 0;
  background-size: cover;
  transition: opacity 0.25 ease 0s;
  height: 600px;
  opacity: 0.3;
}
</style>
